import { render } from "./Select2Ajax.vue?vue&type=template&id=78e663b0"
import script from "./Select2Ajax.vue?vue&type=script&lang=js"
export * from "./Select2Ajax.vue?vue&type=script&lang=js"

import "./Select2Ajax.vue?vue&type=style&index=0&id=78e663b0&lang=scss"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__